import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "./components/Layout/Layout";
import Dashboard from "./components/Layout/Dashboard";
import Login from "./components/common/Login";
import Branch from "./components/pages/Branch";
import { UserProvider } from "./components/Commonfunction/UserContext";
import State from "./components/pages/State";
import Department from "./components/pages/Department";
import Designation from "./components/pages/Designation";
import FinancialYear from "./components/pages/FinancialYear";
import CutOffDate from "./components/pages/CutOffDate";
import EmailTemplates from "./components/pages/EmailTemplates";
import TaxTable from "./components/pages/TaxTable";
import TaxHead from "./components/pages/TaxHead";
import Employees from "./components/Employees/Employees";
import EmployeesForm from "./components/Employees/EmployeesForm";
import AllClients from "./components/AllClients/AllClients";
import AddClientForm from "./components/AllClients/AddClientForm";
import Settings from "./components/Settings/Settings";
import AddTax from "./components/AllClients/AddTax";
import CustomersFileHistoryFilter from "./components/AllClients/CustomersFileHistoryFilter";
import CustomerfileView from "./components/AllClients/CustomerfileView";
import CustomersFileHistoryFilterForMonthWise from "./components/AllClients/CustomersFileHistoryFilterForMonthWise";
import Permissions from "./components/roles/Permissions";
import CpaListing from "./components/CPA/CpaListing";
import AddEditCpa from "./components/CPA/AddEditCpa";

// Simple authentication state management
const isUserLoggedIn = () => {
  return sessionStorage.getItem("isLoggedIn") === "true";
};

function App() {
  const [authenticated, setAuthenticated] = useState(isUserLoggedIn());

  // Function to handle logout (can be passed to Layout component)
  const handleLogout = () => {
    sessionStorage.removeItem("isLoggedIn");
    localStorage.removeItem("isLoggedIn");
    setAuthenticated(false);
  };

  // Check authentication status on component mount and changes
  useEffect(() => {
    setAuthenticated(isUserLoggedIn());
  }, []);

  const userType = localStorage.getItem("user_type");

  const themes = {
    theme1: {
      mainBgColor: "#fff",
      primaryBgColor: "#cee0e7",
      sidebarTextColor: "#0032742",
    },
    theme2: {
      mainBgColor: "#fff",
      primaryBgColor: "#E7ECF8",
      sidebarTextColor: "#000",
    },
    theme3: {
      mainBgColor: "#fff",
      primaryBgColor: "#b1bcc1",
      sidebarTextColor: "#000",
    },
    theme4: {
      mainBgColor: "#fff",
      primaryBgColor: "#DCF2F1",
      sidebarTextColor: "#000",
    },
    theme5: {
      mainBgColor: "#fff",
      primaryBgColor: "#DDDDDD",
      sidebarTextColor: "#000",
    },
    theme6: {
      mainBgColor: "#fff",
      primaryBgColor: "#F3EEEA",
      sidebarTextColor: "#000",
    },
    theme7: {
      mainBgColor: "#fff",
      primaryBgColor: "#eed29b",
      sidebarTextColor: "#000",
    },
  };
  const [updateTheme, setUpdateTheme] = useState();

  const themeSetting = updateTheme
    ? updateTheme
    : localStorage.getItem("theme_settingtest");
  const [newTheme, setNewTheme] = useState("theme2");

  const finalTheme = themes[newTheme || themeSetting] || themes.theme1;

  useEffect(() => {
    Object?.keys(finalTheme).forEach((key) => {
      document.documentElement.style.setProperty(`--${key}`, finalTheme[key]);
    });
  }, [finalTheme]);

  return (
    <Router basename="/">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
      />
      <Routes>
        {/* Login Routes */}
        <Route
          path="/login"
          element={
            authenticated ? (
              <Navigate to="/" replace />
            ) : (
              <Login setUpdateTheme={setUpdateTheme} />
            )
          }
        />
        <Route
          path="/login/:id"
          element={
            authenticated ? (
              <Navigate to="/" replace />
            ) : (
              <Login setUpdateTheme={setUpdateTheme} />
            )
          }
        />

        {/* Protected Routes */}
        <Route
          path="/"
          element={
            authenticated ? (
              <Layout onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        >
          <Route
            index
            element={
              <Dashboard
                titleName={userType === "CPA" ? "All Employees" : "CPA"}
              />
            }
          />
          <Route
            path="/:id"
            element={
              userType == "CPA" ? (
                <UserProvider action="Customers">
                  <AllClients dashboard="dashboard" />
                </UserProvider>
              ) : (
                <Dashboard
                  apiUrl="api/get-employees-by-cpa-id"
                  titleName="All Employees"
                />
              )
            }
          />
          <Route
            path="/:id/:employeeId"
            element={
              <UserProvider action="Customers">
                <AllClients />
              </UserProvider>
            }
          />
          <Route
            path="/Cpalisting"
            element={
              <UserProvider action="Cpa">
                <CpaListing />
              </UserProvider>
            }
          />
          <Route
            path="/add-cpa"
            element={
              <UserProvider action="Cpa">
                <AddEditCpa />
              </UserProvider>
            }
          />
          <Route
            path="/edit-cpa/:id"
            element={
              <UserProvider action="Cpa">
                <AddEditCpa />
              </UserProvider>
            }
          />
          <Route
            path="master/branch"
            element={
              <UserProvider action="Branch">
                <Branch />
              </UserProvider>
            }
          />
          <Route
            path="master/state"
            element={
              <UserProvider action="State">
                <State />
              </UserProvider>
            }
          />
          <Route
            path="master/department"
            element={
              <UserProvider action="Department">
                <Department />
              </UserProvider>
            }
          />
          <Route
            path="master/designation"
            element={
              <UserProvider action="Designation">
                <Designation />
              </UserProvider>
            }
          />
          <Route
            path="master/financialyear"
            element={
              <UserProvider action="FinancialYear">
                <FinancialYear />
              </UserProvider>
            }
          />
          <Route
            path="master/cutofdate"
            element={
              <UserProvider action="Cutoffdate">
                <CutOffDate />
              </UserProvider>
            }
          />
          <Route
            path="master/emailtemplates"
            element={
              <UserProvider action="EmailTemplates">
                <EmailTemplates />
              </UserProvider>
            }
          />
          <Route
            path="master/taxtable"
            element={
              <UserProvider action="County">
                <TaxTable />
              </UserProvider>
            }
          />
          <Route
            path="master/taxhead"
            element={
              <UserProvider action="TaxHead">
                <TaxHead />
              </UserProvider>
            }
          />
          <Route
            path="employees"
            element={
              <UserProvider action="Employees">
                <Employees />
              </UserProvider>
            }
          />
          <Route
            path="Client"
            element={
              <UserProvider action="Cpa">
                <AllClients />
              </UserProvider>
            }
          />
          <Route
            path="add-employee"
            element={
              <UserProvider action="Employees">
                <EmployeesForm />
              </UserProvider>
            }
          />
          <Route
            path="edit-employee/:id"
            element={
              <UserProvider action="Employees">
                <EmployeesForm />
              </UserProvider>
            }
          />
          <Route
            path="/role/Employee/permission/:id"
            element={
              <UserProvider action="Employees">
                <Permissions />
              </UserProvider>
            }
          />
          <Route
          path="/role/cpa/permission/:id"
          element={
            <UserProvider action="Cpa">
              <Permissions />
            </UserProvider>
          }
        />
          <Route path="add-client" element={<AddClientForm />} />
          <Route
            path="edit-client/:id"
            element={
              <UserProvider action="Customers">
                <AddClientForm />
              </UserProvider>
            }
          />
          <Route
            path="/add-tax/:id"
            element={
              <UserProvider action="Customers">
                <AddTax />
              </UserProvider>
            }
          />
          <Route
            path="/add-tax-by-view-customer-file/:id"
            element={
              <UserProvider action="Customers">
                <AddTax customerFile={true} />
              </UserProvider>
            }
          />
          <Route
            path="/tax-history/:id"
            element={
              <UserProvider action="Customers">
                <CustomersFileHistoryFilter />
              </UserProvider>
            }
          />
          <Route
            path="/customer-file/:id"
            element={
              <UserProvider action="Customers">
                <CustomerfileView />
              </UserProvider>
            }
          />
          <Route
            path="/tax-history-by-month/:id"
            element={
              <UserProvider action="Customers">
                <CustomersFileHistoryFilterForMonthWise />
              </UserProvider>
            }
          />
          <Route
            path="settings"
            element={
              <UserProvider action="Employees">
                <Settings setTheme={setNewTheme} />
              </UserProvider>
            }
          />
        </Route>
        

        <Route
          path="*"
          element={
            authenticated ? (
              <Navigate to="/" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
